export default __webpack_public_path__ + "static/media/CoverageIcon.6e102abd.png";